import {useCallback, useEffect, useState} from "react";
import {getMenuItem} from "../menu.service";

export function useMenu(id) {
  const [menu, setMenu] = useState();
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setMenu(await getMenuItem(id));
    } catch (err) {
      setError({
        title: "Failed to fetch menu!",
        message: err.message
      });
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {menu, isLoading, error};
}
